<template>
  <div id="csContainer">
      <div class="fogdiv">
          <div class="shadow">
          <el-checkbox size="small " v-model="checked" label="光照" border></el-checkbox>
          <br/>
          <el-slider v-model="brightvalue"  :min="-1" :max="1" :step="0.05"show-input input-size="mini"></el-slider>
          </div>
      </div>

  </div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'fog',
        data(){
            return{
                checked: true,
                viewer: null,
                brightvalue:0.0
            }
        },
        watch:{
            checked:function (val) {
                if (val === true){
                    this.viewer.scene.globe.enableLighting = false;
                }else if(val === false){
                    this.viewer.scene.globe.enableLighting = true;
                }
            },
            brightvalue:function (val) {
                this.viewer.scene.skyAtmosphere.brightnessShift = val;
            }

        },
        mounted(){
            this.init();
        },

        methods:{
            init(){
                let vm = util.getViewer("csContainer");
                this.viewer = vm;
                this.viewer.scene.fog.enabled = false;
                this.viewer.scene.globe.enableLighting = false;
                let camera = this.viewer.camera;
                camera.setView({
                    destination : Cesium.Cartesian3.fromDegrees(-75.5847, 40.0397, 500.0),
                    orientation: {
                        heading : -Cesium.Math.PI_OVER_TWO,
                        pitch : 0.12,
                        roll : 0.0
                    }
                });

            },



        }
    }
</script>
<style scoped>
  .fogdiv {
      position: absolute;
      margin-left: 25px;
      margin-top: 7px;
      z-index: 999;
      width:260px;
      /*height: 120px;*/
      background-color: rgba(0, 0, 0, 0.5);
  }
  .shadow{
      margin: 10px !important;
      color:white !important;
  }
  .shadow{
      margin: 10px !important;
      color:white !important;
  }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

</style>
